import { useCallback, useMemo } from 'react';

import {
  createSpec,
  specTypes,
  useFetch,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';

import { environmentLookupFn } from '../../../environment/environment-instance';
import {
  fetchRequestContract,
  fetchResponseContract,
} from '../spec/fetch';
import type {
  FetchAndRefetchConfig,
  ReadParameters,
  ReadRequestConfig,
  SaveCouponPayload,
  SaveCouponResult,
  SaveCouponVariables,
} from '../../../types';

const fetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.FETCH, null, environmentLookupFn
);
const refetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.REFETCH, null, environmentLookupFn
);

const DEFAULT_CONFIG = {};


export function useSaveCouponStringForSignup(
  dataLocator: SaveCouponVariables,
  config: FetchAndRefetchConfig<SaveCouponResult, SaveCouponVariables> = DEFAULT_CONFIG
) {
  const dataRefId = useDataRefId(null, environmentLookupFn);

  const defaultConfig = useMemo(() => ({

    fetch: config.fetch || {},

    refetch: config.refetch || {},
  }), [config]);

  const { fetch: fetchConfig, refetch } = defaultConfig;

  const [data, error] = useFetch(dataRefId, fetchSpec, dataLocator, fetchConfig) as [
    SaveCouponResult[] | undefined,
    unknown,
  ];
  const refetchFn = useRefetch(dataRefId, refetchSpec, refetch);

  const update = useCallback((
    param: ReadParameters<SaveCouponVariables, SaveCouponPayload> = {},
    requestConfig?: ReadRequestConfig<SaveCouponResult, SaveCouponVariables>,
    ...rest: Array<ReadRequestConfig<SaveCouponResult, SaveCouponVariables> | undefined>
  ) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
      payload: { ...param.data },
    }, requestConfig, ...rest);
  }, [dataLocator, refetchFn]);

  return [{ data, error }, { update }];
}
